import React, { createContext, useContext, useState } from "react";

const STRINGS = {
  en: {
    home: "Home",
    search: "Search",
    live: "Live",
    shorts: "Shorts",
    following: "Following",
    subscribe: "Subscribe",
    sign_in: "Sign in",
    play: "Play",
    more_info: "More Info",
    continue_watching: "Continue Watching",
    trending: "Trending on Tap IN TV",
    recently_added: "Recently Added",
    live_now: "Live Now",
    featured_creators: "Featured Creators",
    watch_live: "Watch Live",
    next_episode: "Next episode",
    cast: "Cast",
    casting: "Casting",
    like: "Like",
    add_watchlist: "Add to Watchlist",
    in_watchlist: "In Watchlist",
    share: "Share",
    send_tip: "Send a Tip",
    comments: "Comments",
    pin: "Pin",
    unpin: "Unpin",
  },
  es: {
    home: "Inicio",
    search: "Buscar",
    live: "En Vivo",
    shorts: "Cortos",
    following: "Siguiendo",
    subscribe: "Suscribirse",
    sign_in: "Iniciar sesión",
    play: "Reproducir",
    more_info: "Más información",
    continue_watching: "Continuar viendo",
    trending: "Tendencias en Tap IN TV",
    recently_added: "Añadidos recientemente",
    live_now: "En vivo ahora",
    featured_creators: "Creadores destacados",
    watch_live: "Ver en vivo",
    next_episode: "Siguiente episodio",
    cast: "Transmitir",
    casting: "Transmitiendo",
    like: "Me gusta",
    add_watchlist: "Añadir a Mi Lista",
    in_watchlist: "En Mi Lista",
    share: "Compartir",
    send_tip: "Enviar propina",
    comments: "Comentarios",
    pin: "Fijar",
    unpin: "Desfijar",
  },
  pt: {
    home: "Início",
    search: "Buscar",
    live: "Ao Vivo",
    shorts: "Curtas",
    following: "Seguindo",
    subscribe: "Assinar",
    sign_in: "Entrar",
    play: "Reproduzir",
    more_info: "Mais informações",
    continue_watching: "Continuar assistindo",
    trending: "Em alta no Tap IN TV",
    recently_added: "Adicionados recentemente",
    live_now: "Ao vivo agora",
    featured_creators: "Criadores em destaque",
    watch_live: "Assistir ao vivo",
    next_episode: "Próximo episódio",
    cast: "Transmitir",
    casting: "Transmitindo",
    like: "Curtir",
    add_watchlist: "Adicionar à Lista",
    in_watchlist: "Na Lista",
    share: "Compartilhar",
    send_tip: "Enviar gorjeta",
    comments: "Comentários",
    pin: "Fixar",
    unpin: "Desafixar",
  },
  fr: {
    home: "Accueil",
    search: "Rechercher",
    live: "En Direct",
    shorts: "Courts",
    following: "Abonnements",
    subscribe: "S'abonner",
    sign_in: "Se connecter",
    play: "Lire",
    more_info: "Plus d'infos",
    continue_watching: "Reprendre",
    trending: "Tendances sur Tap IN TV",
    recently_added: "Récemment ajoutés",
    live_now: "En direct",
    featured_creators: "Créateurs en vedette",
    watch_live: "Regarder en direct",
    next_episode: "Épisode suivant",
    cast: "Diffuser",
    casting: "Diffusion",
    like: "J'aime",
    add_watchlist: "Ajouter à ma liste",
    in_watchlist: "Dans ma liste",
    share: "Partager",
    send_tip: "Envoyer un pourboire",
    comments: "Commentaires",
    pin: "Épingler",
    unpin: "Désépingler",
  },
};

const I18nCtx = createContext({ lang: "en", t: (k) => k, setLang: () => {} });

export function I18nProvider({ children }) {
  const [lang, setLangState] = useState(() => (typeof window !== "undefined" && localStorage.getItem("tv_lang")) || "en");
  const setLang = (l) => { localStorage.setItem("tv_lang", l); setLangState(l); };
  const t = (key) => STRINGS[lang]?.[key] ?? STRINGS.en[key] ?? key;
  return <I18nCtx.Provider value={{ lang, t, setLang, languages: Object.keys(STRINGS) }}>{children}</I18nCtx.Provider>;
}

export const useI18n = () => useContext(I18nCtx);
